import { render, staticRenderFns } from "./tableFaqGeneral.vue?vue&type=template&id=45702272&scoped=true"
import script from "./tableFaqGeneral.vue?vue&type=script&lang=js"
export * from "./tableFaqGeneral.vue?vue&type=script&lang=js"
import style0 from "./tableFaqGeneral.vue?vue&type=style&index=0&id=45702272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45702272",
  null
  
)

export default component.exports